<template>
  <v-container>
    <div v-if="!Loading">
      <v-row justify="center">
        <v-col md="10">
          <v-container>
            <v-card>
              <v-toolbar
                color="primary"
                dark>
                <v-toolbar-title>
                  <v-icon>supervisor_account</v-icon>生徒一覧
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <span
                  v-if="this.parents.length === 0"
                  class="text--primary">現在応募可能な生徒はいません。</span>
                <span
                  v-else
                  class="text--primary">リクエスト承認済の生徒に授業の応募ができます。</span>
                <v-dialog
                  v-model="dialog"
                  persistent
                  max-width="600px">
                  <template
                    v-slot:activator="{ on }">
                    <span
                      class="caption"
                      style="cursor:pointer"
                      v-on="on">
                      <u>あなたの応募状況</u>
                    </span>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">
                        応募内容
                      </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-container>
                      <v-card-text
                        v-if="this.offers.length() === 0">
                        <span class="text--primary">現在の応募はありません。</span>
                      </v-card-text>
                    </v-container>
                    <OffersByTeacherList
                      v-for="offer in this.offers.get()"
                      :key="offer.id"
                      :offer="offer"
                      @confirm="confirm(offer)"
                    />
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="dialog=false">
                        閉じる
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card-text>
            </v-card>
          </v-container>
          <v-container>
            <v-row>
              <MatchingStudentsList
                v-for="parent in this.parents"
                :key="parent.personalName"
                :parent="parent"
                :offers="offers"
                @deleteParent="deleteParent(parent)"
                @afterSending="afterSending"
              />
              <v-dialog
                v-model="hasDeleted"
                persistent
                max-width="350px">
                <v-card>
                  <v-row justify="center">
                    <v-card-title>
                      リクエストを解除しました。
                    </v-card-title>
                  </v-row>
                  <v-row justify="center">
                    <v-btn
                      text
                      outlined
                      class="ma-5"
                      @click="hasDeleted=false">
                      確認
                    </v-btn>
                  </v-row>
                </v-card>
              </v-dialog>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </div>
    <div
      v-else
      class="max-height">
      <Loading/>
    </div>
  </v-container>
</template>

<script>
import { firestore } from '@/repository/client/firestore.js'
import { StudentRepository } from '@/repository/StudentRepository.js'
import { ParentRepository } from '@/repository/ParentRepository.js'
import { LessonOfferRepository } from '@/repository/LessonOfferRepository.js'
import MatchingStudentsList from '@/components/organisms/teacher/MatchingStudentsList.vue'
import OffersByTeacherList from '@/components/organisms/teacher/OffersByTeacherList.vue'
import Loading from '@/components/organisms/Loading.vue'

export default {
  name: 'StudentsInformation',
  components: {
    'MatchingStudentsList': MatchingStudentsList,
    'OffersByTeacherList': OffersByTeacherList,
    'Loading': Loading,
  },
  data() {
    return {
      parents: [],
      Loading: true,
      dialog: false,
      teacher: this.$store.getters.teacher,
      offers: [],
      hasDeleted: false,
    }
  },
  methods: {
    async confirm(offer) {
      await this.offerRepo.delete(offer)
      this.offers.remove(offer.id)
      this.offers = await this.offerRepo.listOfAllOffers(this.teacher.uuid)
    },
    deleteParent(parent) {
      this.parents.splice(this.parents.findIndex(p => p.id === parent.id), 1)
      this.hasDeleted = true
    },
    async afterSending() {
      this.offers = await this.offerRepo.listOfAllOffers(this.teacher.uuid)
    }
  },
  created: async function() {
    const parentRepo = new ParentRepository(firestore)
    const studentRepo = new StudentRepository(firestore)
    const students = await studentRepo.collect(this.teacher.studentIds)
    this.parents = await parentRepo.collect(students.filterParentId())

    this.offerRepo = new LessonOfferRepository(firestore)
    this.offers = await this.offerRepo.listOfAllOffers(this.teacher.uuid)
    this.Loading = false
  }
}
</script>

